import { LoadablePaint } from '@confluence/loadable';

export const LinksMenuLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-LinksMenu" */ './LinksMenu')).LinksMenu,
});
